import React from "react";
import { ZaunCircleMenuItem } from "./ZaunCircleMenuItem";
import { Aufbau } from "../../arrangement/Aufbau";
import * as Commons from "oc-commons/Commons";
import {
  Abschnittsende,
  getIstSollZwischenabstandDelta,
  LINKS,
  RECHTS,
} from "../../arrangement/elementFunctions";
import { quat } from "oc-threejs/short3";
import * as Maths3 from "oc-threejs/Maths3";
import { I18N } from "oc-I18N";

export function setEmptyAsMauer(empty) {
  empty.elementeAufruecken(true);
  const size = empty.getSize();
  const deltaLinks = getIstSollZwischenabstandDelta(empty, Abschnittsende.Mauer, LINKS);
  const deltaRechts = getIstSollZwischenabstandDelta(empty, Abschnittsende.Mauer, RECHTS);

  // const istLinks = getZwischenabstandAnSeiteVerbose(empty, LINKS);
  // const sollLinks = getSollZwischenabstandVerbose(empty, Abschnittsende.Mauer, LINKS);
  // const istRechts = getZwischenabstandAnSeiteVerbose(empty, RECHTS);
  // const sollRechts = getSollZwischenabstandVerbose(empty, Abschnittsende.Mauer, RECHTS);
  // console.log(
  //   "setEmptyAsMauer 0",
  //   Debugs.roundValues({
  //     istLinks,
  //     sollLinks,
  //     istRechts,
  //     sollRechts,
  //   })
  // );

  const sizeX = size.x;
  size.x += deltaLinks + deltaRechts;
  size.y = 2;
  size.z = 0.5;

  const segment = empty.segment;

  // const deltaCorrection = APP.arrangement.segmente.length == 1 ? 0.08 : 0;
  const emptyMiddleX = segment.getX(empty, 0.5) - deltaLinks / 2 + deltaRechts / 2;

  const x = emptyMiddleX;
  const position = segment.getWorldPositionOfX(x);
  // console.log(
  //   "setEmptyAsMauer 1",
  //   Debugs.roundValues({
  //     deltaLinks,
  //     deltaRechts,
  //     emptyMiddleX,
  //     sizeX,
  //     size_x: size.x,
  //     breite: empty.breite,
  //     position,
  //   })
  // );
  const sizeWorld = Maths3.abs(size.clone().applyQuaternion(empty.getWorldQuaternion(quat())));
  const aufbauMeta = APP.metadata.Aufbauten.find((x) => x.Key == "Mauer");
  const newAufbau = new Aufbau(APP.arrangement, {
    Key: Commons.createUniqueIdString(),
    aufbauMeta,
    position: position,
    size: sizeWorld,
    drehung: 0,
  });
  // console.log(
  //   "setEmptyAsMauer 2",
  //   Debugs.roundValues({
  //     deltaLinks,
  //     deltaRechts,
  //     emptyMiddleX,
  //     size,
  //     sizeWorld,
  //   })
  // );
  // nimm alle parts links und rechts des3
  APP.arrangement.aufbauten.push(newAufbau);
  APP.dirty();
  return newAufbau;
}

export function ZaunCircleMenuItemEmptyAsMauer() {
  const agt = APP.arrangement;
  const contract = () => {
    const elemente = agt.selectedObjects;
    return !elemente.some((e) => !e.isEmpty);
  };
  if (!contract()) {
    return null;
  }
  const label = I18N("Mauer einsetzen");
  return (
    <ZaunCircleMenuItem
      dataButtonKey={label}
      onClick={(event) => {
        event.stopPropagation();
        if (!contract()) {
          return null;
        }
        agt.ghostPool.withPool(() => {
          const mauern = [];
          agt.selectedObjects
            .filter((part) => part.isEmpty)
            .forEach((empty) => {
              const mauer = setEmptyAsMauer(empty);
              mauern.push(mauer);
            });
          APP.arrangement.setSelectedObjects(mauern);
        });
        APP.logUserAction({ action: "insertMauer" });
        APP.dirty();
      }}
    >
      {label}
    </ZaunCircleMenuItem>
  );
}
